import React from "react";
import { SvgIcon } from "@mui/material";

const ShieldIcon = (props: any) => {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 18C8.625 17.5417 7.07292 16.4792 5.84375 14.8125C4.61458 13.1458 4 11.2986 4 9.27083V4.5L10.5 2L17 4.5V9.27083C17 11.2986 16.3854 13.1458 15.1562 14.8125C13.9271 16.4792 12.375 17.5417 10.5 18ZM10.5 16.4375C11.8472 16.0208 12.9688 15.2188 13.8646 14.0312C14.7604 12.8438 15.2847 11.5 15.4375 10H10.5V3.60417L5.5 5.52083V9.27083C5.5 9.39583 5.50694 9.51736 5.52083 9.63542C5.53472 9.75347 5.54861 9.875 5.5625 10H10.5V16.4375Z" fill="#C7C9CD" />
      </svg>
    </SvgIcon>
  );
}

export default ShieldIcon;